import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Modal } from 'react-bootstrap';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { FaUser } from 'react-icons/fa';
import { getAuthToken } from '../../authToken';

const ModalProfilUtilisateur = ({ show, onHide, user_id, onUpdate }) => {
    const [userData, setUserData] = useState({
        email: '',
        nom: '',
        prenoms: '',
        tel: '',
        diplome: '',
        sexe: '',
        profession: '',
        type_financement: '',
        civilite: '',
        type_profil: '',
        nom_organisation: '',
        email_pro: '',
        email_corporate: ''
    });

    const [initialUserData, setInitialUserData] = useState(userData);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingModif, setIsLoadingModif] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });

    useEffect(() => {
        if (show && user_id) {
            fetchUserData();
        }
    }, [show, user_id]);

    const fetchUserData = async () => {
        try {
            setIsLoading(true);

            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
                method: 'get',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            if (!response.ok) throw new Error('Erreur réseau');
            const data = await response.json();
            setUserData(data);
            setInitialUserData(data);
        } catch (error) {
            console.error('Erreur lors du chargement du profil:', error);
            showAlert('Erreur lors du chargement des données', 'danger');
        } finally {
            setIsLoading(false);
        }
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 3000);
    };

    const handleChange = (e) => {
        if (e && e.target && e.target.name) {
            setUserData({
                ...userData,
                [e.target.name]: e.target.value
            });
        }
    };

    const handlePhoneChange = (value) => {
        setUserData({
            ...userData,
            tel: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoadingModif(true);
            const token = localStorage.getItem('access_token');

            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-profil-utilisateur/${user_id}/${user_id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(userData)
            });

            if (!response.ok) throw new Error('Erreur réseau');

            showAlert('Profil mis à jour avec succès.');
            if (onUpdate) onUpdate(userData);

            setTimeout(() => {
                onHide();
            }, 1000);

        } catch (error) {
            console.error('Erreur lors de la modification du profil:', error);
            showAlert('Erreur lors de la modification du profil', 'danger');
        } finally {
            setIsLoadingModif(false);
        }
    };

    const handleReset = () => {
        setUserData(initialUserData);
    };

    const handleClose = () => {
        setUserData(initialUserData);
        setAlert({ message: '', type: '' });
        setTimeout(() => {
            onHide();
        }, 100);
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static">
            <Modal.Header>
                <Modal.Title className="d-flex align-items-center">
                    <FaUser size={25} className="mr-2" />
                    Profil utilisateur
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {alert.message && (
                    <div className={`alert alert-${alert.type} row justify-content-between position-relative m-1 mb-3`}>
                        <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                    </div>
                )}

                {isLoading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-success" role="status">
                            <span className="sr-only">Chargement...</span>
                        </div>
                        <p className="mt-2">Chargement des données...</p>
                    </div>
                ) : (
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            {/* Civilité */}
                            <Col md={6}>
                                <Form.Group className="mb-3" controlId="civilite">
                                    <Form.Label>Civilité</Form.Label>
                                    <Form.Select
                                        name="civilite"
                                        value={userData.civilite}
                                        onChange={handleChange}
                                        className="custom-select"
                                    >
                                        <option value="">Choisir la civilité</option>
                                        <option value="Monsieur">Monsieur</option>
                                        <option value="Madame">Madame</option>
                                        <option value="Mademoiselle">Mademoiselle</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            {/* Type de profil */}
                            <Col md={6}>
                                <Form.Group className="mb-3" controlId="type_profil">
                                    <Form.Label>Type de profil</Form.Label>
                                    <Form.Select
                                        name="type_profil"
                                        value={userData.type_profil}
                                        onChange={handleChange}
                                        className="custom-select"
                                    >
                                        <option value="">Choisir le type de profil</option>
                                        <option value="Apprenant">Apprenant</option>
                                        <option value="Partenaire">Partenaire</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3" controlId="nom">
                                    <Form.Label>Nom</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nom"
                                        value={userData.nom}
                                        onChange={handleChange}
                                        className="custom-input"
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3" controlId="prenoms">
                                    <Form.Label>Prénoms</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="prenoms"
                                        value={userData.prenoms}
                                        onChange={handleChange}
                                        className="custom-input"
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3" controlId="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={userData.email}
                                        onChange={handleChange}
                                        className="custom-input"
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3" controlId="tel">
                                    <Form.Label>Téléphone WhatsApp</Form.Label>
                                    <PhoneInput
                                        value={userData.tel}
                                        onChange={handlePhoneChange}
                                        containerStyle={{ width: '100%' }}
                                        inputProps={{
                                            name: 'tel',
                                            required: true,
                                        }}
                                        dropdownStyle={{
                                            maxHeight: '500px',
                                            overflowY: 'auto',
                                            zIndex: 1050,
                                        }}
                                    />
                                </Form.Group>
                            </Col>

                            {/* Email professionnel (pour tous) */}
                            <Col md={6}>
                                <Form.Group className="mb-3" controlId="email_pro">
                                    <Form.Label>Email professionnel</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email_pro"
                                        value={userData.email_pro}
                                        onChange={handleChange}
                                        className="custom-input"
                                    />
                                </Form.Group>
                            </Col>

                            {/* Champs organisation pour partenaire */}
                            {userData.type_profil === 'Partenaire' && (
                                <>
                                    <Col md={6}>
                                        <Form.Group className="mb-3" controlId="nom_organisation">
                                            <Form.Label>Nom de l'organisation</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="nom_organisation"
                                                value={userData.nom_organisation}
                                                onChange={handleChange}
                                                className="custom-input"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3" controlId="email_corporate">
                                            <Form.Label>Email de l'organisation</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email_corporate"
                                                value={userData.email_corporate}
                                                onChange={handleChange}
                                                className="custom-input"
                                            />
                                        </Form.Group>
                                    </Col>
                                </>
                            )}

                            {/* Champs pour Apprenant */}
                            {userData.type_profil === 'Apprenant' && (
                                <>
                                    <Col md={6}>
                                        <Form.Group className="mb-3" controlId="profession">
                                            <Form.Label>Profession</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="profession"
                                                value={userData.profession}
                                                onChange={handleChange}
                                                className="custom-input"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3" controlId="type_financement">
                                            <Form.Label>Type de financement</Form.Label>
                                            <Form.Select
                                                name="type_financement"
                                                value={userData.type_financement}
                                                onChange={handleChange}
                                                className="custom-select"
                                            >
                                                <option value="">Choisir type de financement</option>
                                                <option value="Particulier">Particulier</option>
                                                <option value="Entreprise">Entreprise</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3" controlId="diplome">
                                            <Form.Label>Diplôme le plus élevé</Form.Label>
                                            <Form.Select
                                                name="diplome"
                                                value={userData.diplome}
                                                onChange={handleChange}
                                                className="custom-select"
                                            >
                                                <option value="">Diplôme le plus élevé</option>
                                                <option value="BAC">BAC</option>
                                                <option value="BTS">BTS</option>
                                                <option value="Licence">Licence</option>
                                                <option value="Master1">Master1</option>
                                                <option value="Master2">Master2</option>
                                                <option value="Doctorat">Doctorat</option>
                                                <option value="Ingénieur">Ingénieur</option>
                                                <option value="Autres">Autres</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </>
                            )}
                        </Row>
                    </Form>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fermer
                </Button>
                <Button
                    variant="success"
                    onClick={handleSubmit}
                    disabled={isLoadingModif || isLoading}
                >
                    {isLoadingModif ? (
                        <>
                            <i className="fa fa-spinner fa-spin mr-1"></i>
                            Modification...
                        </>
                    ) : (
                        'Enregistrer'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalProfilUtilisateur;